<template>
    <tooltip
            :direction="'bottom-right-direction'"
            :add-class-wrap="'h-user'"
            :add-class-btn="'l'"
            :is-btn-close="false"
            :btn-big="true"
            :add-class="'h-user-menu'">
        <template v-slot:tooltipBtn>
            <span class="t" v-if="user.firstName">
                {{ user.firstName.charAt(0) }}
            </span>
        </template>

        <template v-slot:tooltipContent>
            <div class="h-user-menu__item">
                <span class="t">{{ user.lastName }} {{ user.firstName }} {{ user.secondName }}</span>

            </div>

            <div class="h-user-menu__item">
                <span class="t">{{ user.phone }}</span>

            </div>
            <div class="h-user-menu__item">
                <div class="text-size-xs">
                    Рабочее время (по МСК):
                </div>
                <a href="javascript:void(0);" @click="openWorkTime" class="work-time">{{ user.workTimeStart }}–{{ user.workTimeEnd }}</a>
            </div>
            <div class="h-user-menu__bottom">
                <button @click="logout()" class="btn btn--mini">
                  <span class="i-wrapper">
                    <span class="i i-exit2-mini"></span>
                  </span>
                  <span class="t">Выйти</span>
                </button>
            </div>
        </template>
    </tooltip>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue';
import {mapState} from "vuex";

export default {
    name: "UserTooltip",
    components: {
        Tooltip,
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            popups: state => state.popups.items,
        }),
    },
    methods: {
        openWorkTime(){
            this.$store.dispatch('popups/open', {name: this.popups.workTime.name});
        },
        logout(){
            this.$router.push('/');
            this.$store.commit('auth/setStep',{ step:1 })
            this.$store.dispatch('auth/clearUserAuthInfo');
            this.$store.commit('menus/clearActivePath');
        }
    }
}
</script>

<style scoped>

</style>
